export default __webpack_public_path__ + "static/media/editar.11b91900.svg";